import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

export default function AttendeePicker({ label, value, onChange, ...props }) {
  const handleIncrement = () => {
    onChange(value + 1);
  };

  const handleDecrement = () => {
    if (value > 0) {
      onChange(value - 1);
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    
    // Allow empty input - reset to 0
    if (inputValue === '') {
      onChange(0);
      return;
    }
    
    // Only allow valid positive integers
    const newValue = parseInt(inputValue, 10);
    if (!isNaN(newValue) && newValue >= 0 && inputValue === newValue.toString()) {
      onChange(newValue);
    }
    // If invalid input, don't change the value (user can continue typing)
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'center' }}>
          {label}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'stretch', gap: 1, justifyContent: 'center' }}>
        <Button
          variant="outlined"
          size="small"
          onClick={handleDecrement}
          disabled={value <= 0}
          aria-label={`Decrease ${label.toLowerCase()}`}
          sx={{ 
            minWidth: 40, 
            width: 40, 
            height: 40,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderColor: '#ff6b6b',
            color: '#ff6b6b',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              backgroundColor: '#ff6b6b',
              color: 'white',
              transform: 'scale(1.05)',
              boxShadow: '0 4px 8px rgba(255, 107, 107, 0.3)'
            },
            '&:active': {
              transform: 'scale(0.95)'
            },
            '&.Mui-disabled': {
              borderColor: '#ccc',
              color: '#ccc'
            }
          }}
        >
          <Remove fontSize="small" />
        </Button>
        <TextField
          type="number"
          value={value}
          onChange={handleInputChange}
          inputProps={{ 
            min: 0,
            'aria-label': `Number of ${label.toLowerCase()}`,
            'aria-describedby': `${label.replace(/\s+/g, '-').toLowerCase()}-description`
          }}
          sx={{ 
            width: 80,
            '& .MuiInputBase-root': {
              height: 40
            },
            '& .MuiInputBase-input': {
              textAlign: 'center',
              // Hide native number input spinner arrows
              '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0
              },
              '&[type=number]': {
                MozAppearance: 'textfield'
              }
            }
          }}
          size="small"
          {...props}
        />
        <Button
          variant="outlined"
          size="small"
          onClick={handleIncrement}
          aria-label={`Increase ${label.toLowerCase()}`}
          sx={{ 
            minWidth: 40, 
            width: 40, 
            height: 40,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderColor: '#51cf66',
            color: '#51cf66',
            transition: 'all 0.2s ease-in-out',
            '&:hover': {
              backgroundColor: '#51cf66',
              color: 'white',
              transform: 'scale(1.05)',
              boxShadow: '0 4px 8px rgba(81, 207, 102, 0.3)'
            },
            '&:active': {
              transform: 'scale(0.95)'
            }
          }}
        >
          <Add fontSize="small" />
        </Button>
      </Box>
    </Box>
  );
}